import AgencyHelper from "features/Agency/agencyHelper";
import ChargeHelper from "features/Charge/chargeHelper";
import KTFormInput, { KTFormInputType } from "general/components/OtherKeenComponents/Forms/KTFormInput";
import KTBSDropdown from "general/components/OtherKeenComponents/KTBSDropdown";
import DropdownMultiChoiceView from "general/components/quybka/Others/DropdownMultiChoiceView";
import UIHelper from "general/helpers/UIHelper";
import Utils from "general/utils/Utils";
import PropTypes from "prop-types";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

AgencySaleAddPremiseView.propTypes = {
    setSelectedPremise: PropTypes.func,
    selectedPremise: PropTypes.object,
    readyToValidData: PropTypes.bool,
    selectedAreaProvince: PropTypes.object,
    setSelectedAreaProvince: PropTypes.func,
    selectedAreaDistrict: PropTypes.object,
    setSelectedAreaDistrict: PropTypes.func,
    commissionGrounds: PropTypes.array,
    disabled: PropTypes.bool,
};

function AgencySaleAddPremiseView({
    setSelectedPremise,
    selectedPremise,
    readyToValidData,
    selectedAreaProvince,
    setSelectedAreaProvince,
    selectedAreaDistrict,
    setSelectedAreaDistrict,
    commissionGrounds,
    disabled = false,
}) {
    const areaTree = useSelector((state) => state.app.areaTree);

    useEffect(() => {
        if (selectedPremise) {
            const areaId = selectedPremise.areaId;
            const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
            const parentAreaId = area?.parentId;
            const parentArea = ChargeHelper.Utils.getAreaById([areaTree], parentAreaId);
            if (area?.typeCode === 'W') {
                setSelectedAreaDistrict(area);
                if (parentArea?.typeCode === 'P') {
                    setSelectedAreaProvince(parentArea);
                }
            } else if (area?.typeCode === 'P') {
                setSelectedAreaProvince(area);
            }
        }
    }, [selectedPremise, areaTree]);

    const rentingFormOptions = [
        { value: 'Miễn phí', name: 'Miễn phí' },
        { value: 'Có phí', name: 'Có phí' },
    ]

    // khu vuc
    const areaProvinceList = useMemo(() => {
        return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
    }, [areaTree]);
    const areaProvinceOptions = useMemo(() => {
        return _.map(areaProvinceList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaProvinceList]);

    const areaDistrictList = useMemo(() => {
        if (!selectedAreaProvince) return [];
        return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
    }, [areaTree, selectedAreaProvince]);
    const areaDistrictOptions = useMemo(() => {
        return _.map(areaDistrictList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaDistrictList]);

    return (
        <div className="row">
            <div className='col-4 pr-2 mb-4'>
                {UIHelper.buildFormLabel('Tên mặt bằng', true)}
                <KTFormInput
                    name='name'
                    value={selectedPremise?.name}
                    onChange={(value) => {
                        setSelectedPremise({
                            ...selectedPremise,
                            name: value
                        })
                    }}
                    enableCheckValid={readyToValidData}
                    type={KTFormInputType.text}
                    placeholder={'Nhập tên mặt bằng'}
                    isValid={Utils.isValid(selectedPremise.name)}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.name) ? 'Vui lòng nhập tên mặt bằng' : ''}
                    disabled={disabled}
                />
            </div>
            <div className='col-4 px-2 mb-4'>
                {UIHelper.buildFormLabel('Loại mặt bằng', true)}
                <KTBSDropdown
                    toggleElement={({ showError }) => (
                        <button
                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between 
                                ${showError ? 'border-invalid' : ''}
                                ${disabled ? 'disabled' : ''}`}
                            type="button"

                        >
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {selectedPremise?.type?.length ? commissionGrounds?.find(commission => commission?.key === selectedPremise?.type)?.name : 'Chọn loại mặt bằng'}
                            </span>
                        </button>
                    )}
                    selectedValue={selectedPremise?.type}
                    dropdownMenuItems={
                        commissionGrounds?.map((commission) => ({
                            name: commission.name,
                            value: commission?.key,
                        })) || []
                    }
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    dropdownMenuClassName="overflow-auto w-100"
                    onChange={(value) => {
                        setSelectedPremise({
                            ...selectedPremise,
                            type: value
                        })
                    }}
                    enableCheckValid={readyToValidData}
                    isValid={Utils.isValid(selectedPremise?.type)}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.type) ? 'Vui lòng chọn loại mặt bằng' : ''}
                    isDropdownForm={true}
                    disabled={disabled}
                />
            </div>
            <div className='col-4 pl-2 mb-4'>
                {UIHelper.buildFormLabel('Diện tích', true)}
                <KTFormInput
                    name="floorArea"
                    value={selectedPremise?.floorArea}
                    onChange={(value) => {
                        setSelectedPremise({
                            ...selectedPremise,
                            floorArea: value
                        })
                    }}
                    enableCheckValid={readyToValidData}
                    type={KTFormInputType.number}
                    placeholder={'Nhập số'}
                    isValid={Utils.isValid(selectedPremise.floorArea) && selectedPremise?.floorArea > 0}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.name)
                        ? 'Vui lòng nhập diện tích mặt bằng'
                        : selectedPremise.floorArea <= 0 ? 'Diện tích mặt bằng phải lớn hơn 0' : ''}
                    unit="m2"
                    disabled={disabled}
                />
            </div>
            <div className='col-4 pr-2 mb-4'>
                {UIHelper.buildFormLabel('Loại phương tiện', true)}
                <DropdownMultiChoiceView
                    items={ChargeHelper.Data.vehicleTypeOptions}
                    initialSelectedValues={selectedPremise?.vehicleTypes?.length > 0 ? selectedPremise?.vehicleTypes?.split(',') : []}
                    onChange={(items) => {
                        const selectedItems = Array.isArray(items) ? items : [];
                        const updatedPremise = {
                            ...selectedPremise,
                            vehicleTypes: selectedItems.join(','),
                            parkingSlots: selectedItems.includes('CAR') ? selectedPremise.parkingSlots : 0
                        };
                        setSelectedPremise(updatedPremise);
                    }}
                    hasCheckAll={false}
                    placeholder='Chọn loại phương tiện'
                    readyToValidData={readyToValidData}
                    disabled={disabled}
                />
            </div>
            <div className='col-4 px-2 mb-4'>
                {UIHelper.buildFormLabel('Phạm vi thuê', true)}
                <KTBSDropdown
                    toggleElement={({ showError }) => (
                        <button
                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between 
                                ${showError ? 'border-invalid' : ''}
                                ${disabled ? 'disabled' : ''}`}
                            type="button"

                        >
                            {_.find(
                                AgencyHelper.Data.rentingTypeOptions,
                                (item) => item.value === selectedPremise?.rentingType
                            )?.name ?? 'Chọn phạm vi thuê'}
                        </button>
                    )}
                    selectedValue={selectedPremise?.rentingType}
                    dropdownMenuItems={AgencyHelper.Data.rentingTypeOptions}
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    dropdownMenuClassName="overflow-auto w-100"
                    onChange={(value) => {
                        const updatedPremise = {
                            ...(selectedPremise || {}),
                            rentingType: value ?? '',
                            parkingSlots: value === 'FULL' ? 0 : selectedPremise?.parkingSlots ?? 0
                        };
                        setSelectedPremise(updatedPremise);
                    }}
                    enableCheckValid={readyToValidData}
                    isValid={Utils.isValid(selectedPremise?.rentingType)}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.rentingType) ? 'Vui lòng chọn phạm vi thuê' : ''}
                    isDropdownForm={true}
                    disabled={disabled}
                />
            </div>
            <div className='col-4 pl-2 mb-4'>
                {UIHelper.buildFormLabel('Số chỗ đỗ xe ô tô',
                    !(!!selectedPremise.vehicleTypes
                        ? !selectedPremise.vehicleTypes?.split(',')?.includes('CAR') || selectedPremise.rentingType === 'FULL'
                        : true)
                )}
                <KTFormInput
                    name="parkingSlots"
                    value={selectedPremise?.parkingSlots}
                    onChange={(value) => {
                        setSelectedPremise({
                            ...selectedPremise,
                            parkingSlots: value
                        })
                    }}
                    enableCheckValid={readyToValidData}
                    type={KTFormInputType.number}
                    placeholder={'Nhập số'}
                    isValid={Utils.isValid(selectedPremise.parkingSlots) && selectedPremise?.parkingSlots >= 0}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.parkingSlots)
                        ? 'Vui lòng nhập số chỗ đỗ xe ô tô'
                        : selectedPremise.floorArea < 0 ? 'Số chỗ đỗ xe ô tô phải lớn hơn hoặc bằng 0' : ''}
                    unit='Chỗ đỗ'
                    disabled={disabled}
                />
            </div>
            <div className='col-4 pr-2 mb-4'>
                {UIHelper.buildFormLabel('Hình thức thuê', true)}
                <KTBSDropdown
                    name="rentalForm"
                    toggleElement={
                        <button
                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                ${disabled ? 'disabled' : ''}`}
                            type="button"
                        >
                            {_.find(
                                rentingFormOptions,
                                (item) => item.value === selectedPremise?.rentalForm
                            )?.name ?? 'Chọn hình thức thuê'}
                        </button>
                    }
                    selectedValue={selectedPremise?.rentalForm}
                    dropdownMenuItems={rentingFormOptions}
                    dropdownMenuClassName="overflow-auto w-100"
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    onChange={(value) => {
                        setSelectedPremise({
                            ...selectedPremise,
                            rentalForm: value
                        })
                    }}
                    isDropdownForm={true}
                    disabled={disabled}
                />
            </div>
            <div className='col-4 px-2 mb-4'>
                {UIHelper.buildFormLabel('Tỉnh/Thành phố', true)}
                <KTBSDropdown
                    toggleElement={({ showError }) => (
                        <button
                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between 
                                ${!selectedAreaProvince && readyToValidData ? 'button-invalid' : ''}
                                ${disabled ? 'disabled' : ''}`}
                            type="button"
                        >
                            {selectedAreaProvince?.name ?? 'Chọn tỉnh/thành phố'}
                        </button>
                    )}
                    selectedValue={selectedAreaProvince?.areaId}
                    dropdownMenuItems={areaProvinceOptions}
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    dropdownMenuClassName="overflow-auto w-100"
                    onChange={(value) => {
                        setSelectedAreaProvince(_.find(areaProvinceList, (item) => item.areaId === value));
                        setSelectedAreaDistrict(null);
                        const province = _.find(areaProvinceList, (item) => item.areaId === value);
                        setSelectedPremise({
                            ...selectedPremise,
                            areaId: province?.areaId
                        })
                    }}
                    enableCheckValid={readyToValidData}
                    isValid={Utils.isValid(selectedPremise?.areaId)}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.areaId) ? 'Vui lòng chọn tỉnh/thành phố' : ''}
                    isDropdownForm={true}
                    searchable={true}
                    searchFormClassName="mx-3 mt-3 search-form-border"
                    onUnCheck={() => {
                        setSelectedAreaProvince(null);
                        setSelectedAreaDistrict(null);
                        setSelectedPremise({
                            ...selectedPremise,
                            areaId: null
                        })
                    }}
                    disabled={disabled}
                />
            </div>
            <div className='col-4 pl-2 mb-4'>
                {UIHelper.buildFormLabel('Phường/Xã', true)}
                <KTBSDropdown
                    toggleElement={({ showError }) => (
                        <button
                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                 ${!selectedAreaDistrict && readyToValidData ? 'button-invalid' : ''}
                                 ${disabled ? 'disabled' : ''}`}
                            type="button"
                        >
                            {selectedAreaDistrict?.name ?? 'Chọn phường/xã'}
                        </button>
                    )}
                    selectedValue={selectedAreaDistrict?.areaId}
                    dropdownMenuItems={areaDistrictOptions}
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    dropdownMenuClassName="overflow-auto w-100"
                    onChange={(value) => {
                        const area = _.find(areaDistrictList, (item) => item.areaId === value);
                        setSelectedAreaDistrict(area);
                        setSelectedPremise({
                            ...selectedPremise,
                            areaId: area?.areaId
                        })
                    }}
                    enableCheckValid={readyToValidData}
                    isValid={Utils.isValid(selectedPremise?.areaId)}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.areaId) ? 'Vui lòng chọn phường/xã' : ''}
                    isDropdownForm={true}
                    searchable={true}
                    searchFormClassName="mx-3 mt-3 search-form-border"
                    onUnCheck={() => {
                        setSelectedAreaDistrict(null);
                        setSelectedPremise({
                            ...selectedPremise,
                            areaId: selectedAreaProvince?.areaId
                        })
                    }}
                    disabled={disabled}
                />
            </div>
            <div className='col-12 mb-4'>
                {UIHelper.buildFormLabel('Địa chỉ cụ thể', true)}
                <KTFormInput
                    name="address"
                    value={selectedPremise?.address}
                    onChange={(value) => {
                        setSelectedPremise({
                            ...selectedPremise,
                            address: value
                        })
                    }}
                    enableCheckValid={readyToValidData}
                    type={KTFormInputType.text}
                    placeholder={'Nhập số nhà, tên đường, thôn/xóm'}
                    isValid={Utils.isValid(selectedPremise.address)}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.address)
                        ? 'Vui lòng nhập địa chỉ cụ thể'
                        : ''}
                    disabled={disabled}
                />
            </div>
            <div className='col-12 mb-4'>
                {UIHelper.buildFormLabel('Mô tả mặt bằng')}
                <KTFormInput
                    name="description"
                    value={selectedPremise?.description}
                    onChange={(value) => {
                        setSelectedPremise({
                            ...selectedPremise,
                            description: value
                        })
                    }}
                    enableCheckValid={readyToValidData}
                    type={KTFormInputType.text}
                    placeholder={'Nhập mô tả'}
                    isValid={Utils.isValid(selectedPremise.description)}
                    isTouched={readyToValidData}
                    feedbackText={!Utils.isValid(selectedPremise.description)
                        ? 'Vui lòng nhập mô tả'
                        : ''}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}

export default AgencySaleAddPremiseView;